import { CrmObject } from "../generated/graphql";
import { type CrmListFilter, crmListPath } from "./crm";

export const MARKETING_ROUTE = "/marketing";
export const WEB_ORDERS_ROUTE = `${MARKETING_ROUTE}/web-orders`;

// A month of the overview, or all its months when index is null.
const monthRange = (months: string[], index: number | null): Pick<CrmListFilter, "fromMonth" | "toMonth"> =>
  index === null
    ? { fromMonth: months[0], toMonth: months[months.length - 1] }
    : { fromMonth: months[index], toMonth: months[index] };

// The CRM lead lists behind the overview's numbers. A label of undefined
// leaves that field unfiltered; null means leads without a value.
export const newLeadsPath = (
  months: string[],
  index: number | null,
  source?: string | null,
  detail?: string | null
): string =>
  crmListPath(CrmObject.Lead, "all", [
    ...(source === undefined ? [] : [{ key: "leadSource", value: source }]),
    ...(detail === undefined ? [] : [{ key: "leadSourceDetail", value: detail }]),
    { key: "createdAt", ...monthRange(months, index) },
  ]);

export const conversionsPath = (months: string[], index: number | null, target?: string | null): string =>
  crmListPath(CrmObject.Lead, "converted", [
    ...(target === undefined ? [] : [{ key: "convertTo", value: target }]),
    { key: "convertedDate", ...monthRange(months, index) },
  ]);

export const openLeadsPath = (status?: string | null): string =>
  crmListPath(CrmObject.Lead, "open", status === undefined ? [] : [{ key: "status", value: status }]);

const shortMonthFormat = new Intl.DateTimeFormat("de-DE", { month: "short", year: "2-digit", timeZone: "UTC" });

// A YYYY-MM month as a table header: "Okt. 26".
export const formatShortMonth = (month: string): string => shortMonthFormat.format(new Date(`${month}-01T12:00:00Z`));
